import { Slider as MuiSlider } from '@mui/material';
import styled from 'styled-components';

export default function Slider({
  min = 1.0,
  max = 10.0,
  marks = [],
  withThumb,
  ...restProps
}) {
  return (
    <SMuiSlider
      aria-label="Steps"
      marks={marks}
      valueLabelDisplay="auto"
      // valueLabelDisplay={marks.find((item) => input.value === item.value) ? 'on' : 'off'}   //
      // getAriaLabel={(value) => marks.find((item) => item.value === value)?.label}          //  UNLOCK AFTER ADDING LABELS TO METRIC
      // valueLabelFormat={(value) => marks.find((item) => item.value === value)?.label}     //
      min={min}
      max={max}
      track={false}
      withThumb={withThumb}
      {...restProps}
    />
  );
}

const SMuiSlider = styled(MuiSlider)`
  && {
    position: relative;
    .MuiSlider-rail {
      background-color: ${({theme}) => theme.palette.colors.gray300};
    }
    .MuiSlider-mark {
      display: none;
    }
    .MuiSlider-markLabel {
      display: none;
    }
    .MuiSlider-thumb {
      display: ${({ withThumb }) => (withThumb ? 'block' : 'none')};
      z-index: 1;
    }

    .MuiSlider-markLabel[data-index='0'] {
      display: block;
      transform: translateX(0)
    }
    .MuiSlider-markLabel[data-index='${({ marks }) => marks.length - 1}'] {
      display: block;
      transform: translateX(-100%)
    }

    ::before {
      content: '';
      z-index: 0;
      top: 11px;
      position: absolute;
      display: block;
      width: 8px;
      height: 8px;
      background-color: ${({theme}) => theme.palette.colors.gray300};
      border-radius: 6px;
    }
    ::after {
      content: '';
      top: 11px;
      right: 0;
      position: absolute;
      display: block;
      width: 8px;
      height: 8px;
      background-color: ${({theme}) => theme.palette.colors.gray300};
      border-radius: 6px;
      z-index: 0;
    }
  }
`;
